import { useEffect } from "react";

function upsertMeta(attribute, key, content) {
    const selector = `meta[${attribute}="${CSS.escape(key)}"]`;
    let node = document.head.querySelector(selector);
    const created = !node;
    if (!node) {
        node = document.createElement("meta");
        node.setAttribute(attribute, key);
        document.head.appendChild(node);
    }
    const previous = node.getAttribute("content");
    node.setAttribute("content", content);
    return () => {
        if (created) {
            node.remove();
            return;
        }
        if (previous == null) node.removeAttribute("content");
        else node.setAttribute("content", previous);
    };
}

export function usePageMeta(title, description) {
    useEffect(() => {
        const previousTitle = document.title;
        document.title = title;
        const restore = [
            upsertMeta("name", "description", description),
            upsertMeta("property", "og:title", title),
            upsertMeta("property", "og:description", description),
        ];
        return () => {
            document.title = previousTitle;
            restore.forEach((restoreMeta) => restoreMeta());
        };
    }, [title, description]);
}
